export function isValidLayout(layout, validLayouts) {
    return !!layout && typeof layout === "string" && Object.values(validLayouts).includes(layout);
}
export function getValidLayout(validLayouts, requestedLayout, defaultLayout) {
    if (isValidLayout(requestedLayout, validLayouts)) {
        return requestedLayout;
    }
    const firstLayout = Object.entries(validLayouts)[0][1];
    return defaultLayout || firstLayout;
}
//# sourceMappingURL=layouts.js.map